import { render, staticRenderFns } from "./rating-tour.vue?vue&type=template&id=1f85a0ca&"
import script from "./rating-tour.vue?vue&type=script&lang=js&"
export * from "./rating-tour.vue?vue&type=script&lang=js&"
import style0 from "./rating-tour.vue?vue&type=style&index=0&id=1f85a0ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports